import { IonRouterOutlet } from '@ionic/react'
import React from 'react'
import { Route, RouteComponentProps } from 'react-router-dom'
import Login from './Login'

const AuthRouter: React.FC<RouteComponentProps> = ({match}) => {
  return (
    <IonRouterOutlet>
      <Route path={`${match.url}/login`} component={Login} exact={true} />
      <Route path={`${match.url}`} render={() => <div>empty auth!</div>} exact={true} />
    </IonRouterOutlet>
  )
}

export default AuthRouter
